import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify';
// import VueHead from 'vue-head'

// Vue.use(VueHead)
Vue.use(VueRouter)

import Home from './components/Home'
import About from './components/About'
import Contact from './components/Contact'

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', component: Home },
    { path: '/about', component: About },
    { path: '/contact', component: Contact }
  ]
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  vuetify,
  router,
  template: '<App />',
  components: { App }
  // render: function (h) { return h(App) }
})
